/**
 * Normalize sentiment recommendations to remove duplicates and clean formatting
 */
export const normalizeRecommendations = (raw) => {
  const out = [];
  const push = (s) => {
    const txt = (s || "")
      .replace(/^[-•·\s]+/, "")
      .replace(/\s+/g, " ")
      .replace(/[.:;]+$/, "") // quita : . ; finales
      .trim();
    if (txt) out.push(txt);
  };

  if (!raw) return [];

  if (Array.isArray(raw)) {
    raw.forEach((item) => {
      if (typeof item === "string") {
        push(item);
      } else if (item && typeof item === "object") {
        const title = (item.title || item.heading || "").trim();
        const detail = (item.text || item.description || item.detail || "").trim();

        const clean = (v) => v.replace(/[.:;]+$/, "").trim();
        const t = clean(title);
        const d = clean(detail);

        let merged = "";
        if (t && d && t.toLowerCase() !== d.toLowerCase()) merged = `${t}. ${d}`;
        else merged = d || t;
        push(merged);
      }
    });
  } else if (typeof raw === "string") {
    raw.split(/\r?\n|•|;|·/).forEach(push);
  }

  // de-dup case/punct insensitive
  const seen = new Set();
  return out.filter((s) => {
    const key = s.toLowerCase().replace(/[^\p{L}\p{N} ]/gu, "").trim();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};